import React from "react";
import { useSelector } from "react-redux";
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { CentroMedico } from "./CentroMedico";

const useStyles = makeStyles({
    root: {
        paddingLeft: 50,
    },
    rootTitulo: {
        paddingLeft: 50,
        marginTop: 10,
    },
    grid: {
        marginTop: 5, 
        padding: 12
    }
});

export const CentrosMedicos = (props) => {
  const classes = useStyles();
  const { idFeriado, itemsCentrosMedicos, centrosMedicosFeriadoSeleccionado } = props;
  const { centrosMedicos: centrosMedicosUsuario } = useSelector(state => state.auth)
  
  const centros = itemsCentrosMedicos.map( i => {
    const tieneCentro = centrosMedicosFeriadoSeleccionado?.filter(s => !s.idUsuarioBaja).find( s => s.idCentro === i.idCentroMedico );

    return {
        idCentroMedico: i.idCentroMedico,
        descripcionCentro: i.descripcionCentro,
        seleccionado: tieneCentro ? true : false,
        disabled: centrosMedicosUsuario.filter(s => s.idCentroMedico === i.idCentroMedico).length === 0,
    }
  })

  return (
    <>
        <Grid item xs={12} style={{backgroundColor: 'white'}}>
            <Typography component="h3" variant="h5" className={classes.rootTitulo}>Centros Médicos</Typography>
        </Grid>
        <Grid item xs={12} style={{backgroundColor: 'white', paddingLeft: 25}}>
            <Grid item container className={classes.grid}>
            {
                itemsCentrosMedicos&&
                    centros.map(centro => 
                        <CentroMedico
                            fecha={props.fecha}
                            key={centro.idCentroMedico}
                            idFeriado={idFeriado}
                            idCentroMedico={centro.idCentroMedico}
                            seleccionado={centro.seleccionado}
                            descripcionCentro={centro.descripcionCentro}
                            disabled={centro.disabled}
                        />
                    )
            }
            </Grid>
        </Grid>
    </>
  );

};
